/* 
 * Export component file to be used on project
*/

import ModalGeneric from './ModalGeneric.js';
export default ModalGeneric;
